import React from 'react';
import LocationTemplate from './LocationTemplate';

const MacclesfieldPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Macclesfield"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27852"]}
      latitude={35.7468}
      longitude={-77.6731}
      population={471}
      historicalFact="Incorporated in 1901, named after a town in England."
      nearbyTowns={[
        "Tarboro, NC",
        "Pinetops, NC",
        "Rocky Mount, NC",
        "Elm City, NC",
        "Sharpsburg, NC",
        "Nashville, NC",
        "Wilson, NC",
        "Battleboro, NC"
      ]}
    />
  );
};

export default MacclesfieldPage;